import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { ProgramCardCmp, ProgramCardProps } from "./ProgramCard"

export interface ProgramCardWrapperBlokProps {
  blok: ProgramCardProps & blokType
}

const S22ProgramCard: React.FC<ProgramCardWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <ProgramCardCmp
      title={blok.title}
      description={blok.description} 
      degree={blok.degree}    
      header_image={blok.header_image}
      location={blok.location} 
      specialization={blok.specialization} 
      initial_hide={blok.initial_hide}
      duration={blok.duration}
      timeline={blok.timeline}
      cta_web={blok.cta_web}
      cta_lp1={blok.cta_lp1}
      cta_lp2={blok.cta_lp2}
      cta_lp3={blok.cta_lp3}
    />
  </SbEditable>
)

export default S22ProgramCard
